export const FORGET_EMAIL_PASSOWRD = '/forget-password';
export const REGISTER = '/register';
export const RESET_PASSWORD = '/reset-password';
export const PASSWORD_RESET = '/password-reset'; // came from email

export const CONFIRM_EMAIL = '/email-confirm';

export const DASHBOARD = '/dashboard';

export const PROTECTED = '/protected';
export const _LAYOUT = '/_layout';
export const AI_CHAT = '/ai-chat';

// Composed routes for dashboard
export const PROTECTED_DASHBOARD = `${PROTECTED}${DASHBOARD}`;
export const PROTECTED_LAYOUT_DASHBOARD = `${PROTECTED}${_LAYOUT}${DASHBOARD}`;
export const PROTECTED_AI_CHAT = `${PROTECTED}${AI_CHAT}`;
export const PROTECTED_LAYOUT_AI_CHAT = `${PROTECTED}${_LAYOUT}${AI_CHAT}`;
export const TERMS_OF_USE = '/terms';

export const SIGN_IN = '/sign-in';
export const SIGN_UP = '/sign-up';
export const SETTINGS = '/settings';
export const BILLING = '/billing';
export const HELP = '/help';
export const SUPPORT = '/support';
export const STUDIO = '/studio';

export const PREFERENCES = 'preferences';

export const USERS = '/users';

// Cashflow routes
export const COMPANIES = '/companies';
export const ACCOUNTS = '/accounts';
export const CATEGORIES = '/categories';
export const FORECAST = '/forecast';
export const CASH_FLOW = '/cash-flow';
export const DOCUMENTS = '/documents';
export const INVOICES = '/invoices';
export const DELIVERY_NOTES = '/delivery-notes';
export const ORDERS = '/orders';
export const ADMINISTRATION = '/administration';
export const COMMESSE = '/commesse';
export const SERVICE_CONTRACTS = '/service-contracts';
export const WORK_REPORTS = '/work-reports';
export const HOTEL = '/hotel';
export const MACHINES = '/machines';
export const MACHINE_CHECKS = '/machine-checks';
export const REGISTRY = '/registry';
export const PRODUCTS = '/products';
export const WAREHOUSE = '/warehouse';
export const PRICE_LISTS = '/price-lists';
export const INVENTORY = '/inventory';
export const DOCUMENT_PAYMENT_SCHEDULES = '/document-payment-schedules';
export const DISTINTE_RIBA = '/distinte-riba';
export const PAYMENTS = '/payments';
export const FORECAST_OCCURRENCES = '/forecast-occurrences';
// Synchronizations
export const SYNC = '/sync';

export const ACTIONS = {
  NEW: 'new',
  SHOW: 'show',
  EDIT: 'edit',
  DELETE: 'delete',
};

export const TO_INVOICE = '/to-invoice';
